function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 23.011,
    height: 17.451,
    viewBox: "0 0 23.011 17.451"
  }, props), _ref, React.createElement("g", {
    id: "prefix__Icons",
    transform: "translate(-8.502 -13.635)"
  }, React.createElement("g", {
    id: "prefix__Group_325",
    "data-name": "Group 325",
    transform: "translate(8.852 13.985)"
  }, React.createElement("g", {
    id: "prefix__Group_319",
    "data-name": "Group 319"
  }, React.createElement("g", {
    id: "prefix__Group_316",
    "data-name": "Group 316"
  }, React.createElement("g", {
    id: "prefix__Group_315",
    "data-name": "Group 315"
  }, React.createElement("path", {
    id: "prefix__Path_304",
    d: "M24.633 30.724H8.852c.032-1.262-.175-2.76.741-3.646a8.224 8.224 0 0 1 2.652-1.291c.591-.251 1.228-.369 1.8-.657.624-.317.643-.841.351-1.528a14.449 14.449 0 0 1-1.423-3.889 6.46 6.46 0 0 1 .624-4.229 2.636 2.636 0 0 1 .26-.354 3.709 3.709 0 0 1 2.886-1.144",
    className: "prefix__cls-1",
    "data-name": "Path 304",
    transform: "translate(-8.852 -13.985)",
    style: {
      "fill": "none",
      "stroke": "#00949c",
      "strokeLinecap": "round",
      "strokeLinejoin": "round",
      "strokeMiterlimit": 10,
      "strokeWidth": ".7px"
    }
  }))), React.createElement("g", {
    id: "prefix__Group_318",
    "data-name": "Group 318",
    transform: "translate(7.89)"
  }, React.createElement("g", {
    id: "prefix__Group_317",
    "data-name": "Group 317"
  }, React.createElement("path", {
    id: "prefix__Path_305",
    d: "M19.572 13.987a3.709 3.709 0 0 1 2.886 1.144 2.637 2.637 0 0 1 .26.354 6.46 6.46 0 0 1 .624 4.229 14.449 14.449 0 0 1-1.424 3.886c-.292.686-.273 1.21.351 1.528.572.288 1.209.406 1.8.657.507.221 1.053.376 1.566.605h.006a3.492 3.492 0 0 1 1.079.686c.916.886.708 2.384.741 3.646",
    className: "prefix__cls-1",
    "data-name": "Path 305",
    transform: "translate(-19.572 -13.985)",
    style: {
      "fill": "none",
      "stroke": "#00949c",
      "strokeLinecap": "round",
      "strokeLinejoin": "round",
      "strokeMiterlimit": 10,
      "strokeWidth": ".7px"
    }
  })))), React.createElement("g", {
    id: "prefix__Group_324",
    "data-name": "Group 324",
    transform: "translate(9.983 3.676)"
  }, React.createElement("g", {
    id: "prefix__Group_321",
    "data-name": "Group 321"
  }, React.createElement("g", {
    id: "prefix__Group_320",
    "data-name": "Group 320"
  }, React.createElement("path", {
    id: "prefix__Path_306",
    d: "M34.732 31.446h-5.31M26.7 25.989a2.18 2.18 0 0 0-.123-.376 9.06 9.06 0 0 1-.943-2.757 5.007 5.007 0 0 1 .487-3.3 1.632 1.632 0 0 1 .2-.28 2.9 2.9 0 0 1 2.249-.893m-.357 13.062h-5.8m3.978-4.332h-.006",
    className: "prefix__cls-1",
    "data-name": "Path 306",
    transform: "translate(-22.415 -18.383)",
    style: {
      "fill": "none",
      "stroke": "#00949c",
      "strokeLinecap": "round",
      "strokeLinejoin": "round",
      "strokeMiterlimit": 10,
      "strokeWidth": ".7px"
    }
  }))), React.createElement("g", {
    id: "prefix__Group_323",
    "data-name": "Group 323",
    transform: "translate(6.155)"
  }, React.createElement("g", {
    id: "prefix__Group_322",
    "data-name": "Group 322"
  }, React.createElement("path", {
    id: "prefix__Path_307",
    d: "M30.777 18.384a2.917 2.917 0 0 1 2.255.893 2.079 2.079 0 0 1 .2.28 5.047 5.047 0 0 1 .487 3.3 11.381 11.381 0 0 1-1.111 3.033c-.227.539-.215.945.273 1.2.448.221.942.317 1.4.509a6.416 6.416 0 0 1 2.073 1.011c.708.686.546 1.852.578 2.841",
    className: "prefix__cls-1",
    "data-name": "Path 307",
    transform: "translate(-30.777 -18.383)",
    style: {
      "fill": "none",
      "stroke": "#00949c",
      "strokeLinecap": "round",
      "strokeLinejoin": "round",
      "strokeMiterlimit": 10,
      "strokeWidth": ".7px"
    }
  })))), React.createElement("path", {
    id: "prefix__Path_308",
    d: "M28.228 27.486a4.855 4.855 0 0 1 2.057 1.523c.766 1.107.671 2.61.671 3.933",
    className: "prefix__cls-1",
    "data-name": "Path 308",
    transform: "translate(-13.966 -16.203)",
    style: {
      "fill": "none",
      "stroke": "#00949c",
      "strokeLinecap": "round",
      "strokeLinejoin": "round",
      "strokeMiterlimit": 10,
      "strokeWidth": ".7px"
    }
  }), React.createElement("path", {
    id: "prefix__Path_309",
    d: "M17 15.759a2.741 2.741 0 0 0-1.115 2.751",
    className: "prefix__cls-1",
    "data-name": "Path 309",
    transform: "translate(-10.703 -14.276)",
    style: {
      "fill": "none",
      "stroke": "#00949c",
      "strokeLinecap": "round",
      "strokeLinejoin": "round",
      "strokeMiterlimit": 10,
      "strokeWidth": ".7px"
    }
  }), React.createElement("path", {
    id: "prefix__Line_8",
    d: "M0 0L0.142 0.645",
    className: "prefix__cls-1",
    "data-name": "Line 8",
    transform: "translate(5.263 5.362)",
    style: {
      "fill": "none",
      "stroke": "#00949c",
      "strokeLinecap": "round",
      "strokeLinejoin": "round",
      "strokeMiterlimit": 10,
      "strokeWidth": ".7px"
    }
  }))));
};

export default __webpack_public_path__ + "static/media/job_employees.71390844.svg";
export { SvgComponent as ReactComponent };